import React, { useMemo } from "react";

function RecruitmentPagination({ totalPage, pageCurrent, onChangePage }) {
  const maxPages = 4;

  const pagePagination = useMemo(() => {
    const middle = Math.floor(maxPages / 2);
    let start, end;

    if (totalPage <= maxPages) {
      start = 1;
      end = totalPage;
    } else if (pageCurrent <= middle) {
      start = 1;
      end = maxPages;
    } else if (pageCurrent >= totalPage - middle) {
      start = totalPage - maxPages + 1;
      end = totalPage;
    } else {
      start = pageCurrent - middle;
      end = pageCurrent + middle;
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (start > 1) {
      pages.unshift("...");
      pages.unshift(1);
    }

    if (end < totalPage) {
      pages.push("...");
      pages.push(totalPage);
    }

    return pages;
  }, [totalPage, pageCurrent]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPage) {
      onChangePage(page);
    }
  };

  return (
    <div style={{ margin: "20px 0" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          disabled={pageCurrent === 1}
          onClick={() => handlePageChange(pageCurrent - 1)}
          style={{
            padding: "10px 20px",
            cursor: pageCurrent === 1 ? "not-allowed" : "pointer",
          }}
        >
          Trước
        </button>

        <div style={{ display: "flex" }}>
          {pagePagination.map((item, index) =>
            item !== "..." ? (
              <div
                key={index}
                onClick={() => handlePageChange(item)}
                style={{
                  padding: "8px 17px",
                  cursor: "pointer",
                  borderRadius: "5px",
                  color: pageCurrent === item ? "#27C6FF" : "#919191",
                  backgroundColor:
                    pageCurrent === item ? "#E1F7FF" : "transparent",
                }}
              >
                {item}
              </div>
            ) : (
              <div
                key={index}
                style={{
                  padding: "8px 17px",
                  cursor: "default",
                  color: "#64748B",
                }}
              >
                ...
              </div>
            )
          )}
        </div>

        <button
          disabled={pageCurrent === totalPage}
          onClick={() => handlePageChange(pageCurrent + 1)}
          style={{
            padding: "10px 20px",
            cursor: pageCurrent === totalPage ? "not-allowed" : "pointer",
          }}
        >
          Sau
        </button>
      </div>
    </div>
  );
}

export default RecruitmentPagination;
